export const SgrTchProducts = {
  scopes: [process.env.PRODUCTS_B2C_SCOPE]
};

export const SgrTchTickets = {
  scopes: [process.env.TICKETS_B2C_SCOPE]
};

export const SgrTchGeography = {
  scopes: [process.env.GEOGRAPHY_B2C_SCOPE]
};

export const SgrTchClients = {
  scopes: [process.env.CLIENTS_B2C_SCOPE]
};

export const SgrTchCatalogs = {
  scopes: [process.env.CATALOGS_B2C_SCOPE]
};

export const SgrTchInventory = {
  scopes: [process.env.INVENTORY_B2C_SCOPE]
};

export const SgrTchFileStorage = {
  scopes: [process.env.FILE_STORAGE_B2C_SCOPE]
};

export const SgrTchSecurity = {
  scopes: [process.env.SECURITY_B2C_SCOPE]
};

export const SgrTchMessageCommunication = {
  scopes: [process.env.MESSAGE_COMMUNICATION_B2C_SCOPE]
};

export const SgrTchInsight = {
  scopes: [process.env.INSIGHT_B2C_SCOPE]
};

export const SgrTchProcess = {
  scopes: [process.env.PROCESS_B2C_SCOPE]
};

export default {
  SgrTchProducts,
  SgrTchTickets,
  SgrTchGeography,
  SgrTchClients,
  SgrTchCatalogs,
  SgrTchInventory,
  SgrTchFileStorage,
  SgrTchSecurity,
  SgrTchMessageCommunication,
  SgrTchInsight,
  SgrTchProcess
};
